export interface ForumWindow extends Window {
  PHP: any;
}

const forumWindow = window as ForumWindow;

if (typeof forumWindow.PHP === 'undefined') {
  /* tslint:disable:no-bitwise prefer-for-of */
  forumWindow.PHP = {
    urlencode(text: string) {
      text = text.toString();

      // this escapes 128 - 255, as JS uses the unicode code points for them.
      // This causes problems with submitting text via AJAX with the UTF-8 charset.
      const matches = text.match(/[\x90-\xFF]/g);
      if (matches) {
        for (let matchId = 0; matchId < matches.length; matchId++) {
          const charCode = matches[matchId].charCodeAt(0);
          text = text.replace(matches[matchId], '%u00' + (charCode & 0xFF).toString(16).toUpperCase());
        }
      }

      return escape(text).replace(/\+/g, '%2B');
    },
  };
  /* tslint:enable:no-bitwise prefer-for-of */
}

import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';
